module.exports = __webpack_public_path__ + "img/pacote-performance-total.2dc2e1c4.jpg";